import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  successMsg: '',
  isSuccessDelete: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.DELETE_IMAGE_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccessDelete: false,
        successMsg: '',
      };
    case actionConstants.DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        isfetching: false,
        isSuccessDelete: true,
        successMsg: action.message,
      };
    case actionConstants.DELETE_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isfetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        isSuccessDelete: false,
        successMsg: '',
        error: '',
      };
    default:
      return state;
  }
};
